import styled from "styled-components";
import { ReactComponent as ArrowRight } from "../../assets/icons/arrow-right.svg";

const FinanceCard = ({
  title,
  description,
  buttonText = "Calculate now",
  onClick,
}) => {
  return (
    <CardWrapper>
      <div>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </div>
      <ActionButton onClick={onClick}>
        {buttonText} <ArrowRight size={16} />
      </ActionButton>
    </CardWrapper>
  );
};

export default FinanceCard;

const CardWrapper = styled.div`
  background-color: #154cd61a;
  border-radius: 16px;
  padding: 1.75rem;
  max-width: 440px;
  width: 100%;
  min-height: 350px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 768px) {
    padding: 1.25rem;
    min-height: auto;
  }
`;

const Title = styled.h3`
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 0.75rem;
  color: #222222;
`;

const Description = styled.p`
  font-size: 0.95rem;
  line-height: 1.6;
  color: #222222;
  margin-bottom: 1.25rem;
`;

const ActionButton = styled.button`
  background-color: #ffffff;
  color: #0057d9;
  font-weight: 500;
  font-size: 0.9rem;
  padding: 0.6rem 1.25rem;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: 0.3s ease;
  border: 1px solid #0057d9;
  cursor: pointer;
  width: fit-content;

  &:hover {
    background-color: #f0f0f0;
  }
`;
